import * as React from 'react';
import { Component, Props } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import i18next from 'i18next';
import { HomeButtonView } from '../Buttons/HomeButton/HomeButtonView';
import OpenedCountriesHomeView from './OpenedCountriesHomeView';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect, Dispatch } from 'react-redux';
import { AppState } from '../../reducers';
import { getOpenedCountriesAction } from '../../actions/OpenedCountries/openedCountries';
import { OpenedCountry } from '../../models/OpenedCountries/openedCountries';
import OpenedCountriesResultsView from './OpenedCountriesResultsView';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface CovidHomeContainerState {
    filters: Array<string>;
    q: string;
    isShowResults: boolean;
}

interface CovidHomeContainerProps extends Props<OpenedCountriesHomeContainer> {
    countries: OpenedCountry[];
    loading: boolean;
    error: string;
    userId: string;
}

interface CovidHomeContainerDispatch extends Props<OpenedCountriesHomeContainer> {
    getOpenedCountries: (filters: string, q?: string) => any;
}

function mapProps(state: AppState, props: CovidHomeContainerProps): CovidHomeContainerProps {
    return {
        countries: state.openedCountriesState.countries,
        loading: state.openedCountriesState.loading,
        error: state.openedCountriesState.error,
        userId: state.userState.userId
    };
}

function mapDispatch(dispatch: Dispatch<any>) {
    return {
        getOpenedCountries: (filters: string, q?: string) => dispatch(getOpenedCountriesAction(filters, q)),
    };
}

type AllProps = CovidHomeContainerProps & CovidHomeContainerDispatch & RouteProps;

class OpenedCountriesHomeContainer extends Component<AllProps> {

    state: CovidHomeContainerState = {
        filters: ['no_visa'],
        q: '',
        isShowResults: false
    };

    componentDidMount() {
        document.title = i18next.t('conditions');
    }

    setFilters = (key: string) => {
        const { filters } = this.state;
        let newFilters = filters;
        const index = newFilters.indexOf(key);
        if (index !== -1) {
            newFilters.splice(index, 1);
        } else {
            newFilters.push(key);
        }
        if (key === 'visa') {
            newFilters.push('no_visa');
        }
        if (key === 'no_visa') {
            newFilters.push('visa');
        }
        this.setState({filters: newFilters});
    }

    onSearch = (q?: string) => {
        const { getOpenedCountries } = this.props;
        const { filters } = this.state;
        q ? getOpenedCountries(encodeURI(filters.join('&filters[]=')), q) : getOpenedCountries(encodeURI(filters.join('&filters[]=')));
        this.setState({isShowResults: true});
    }

    onChangeQ = (q: string) => {
        this.setState({q});
        this.onSearch(q);
    }

    render() {
        const { filters, isShowResults, q } = this.state;
        const { history, countries, loading, error, userId } = this.props;

        return (
            <div className='container'>
                <HomeButtonView
                    clickHome={() => history.push(`/services?user_id=${encodeURIComponent(localStorage.KON_USER_ID)}&channel_id=${localStorage.KON_CHANNEL_ID}&lang=${localStorage.KON_LANG}&tariff_id=${localStorage.KON_TARIFF_ID}`)}
                    fixed={true}
                    back={isShowResults}
                    clickBack={() => this.setState({isShowResults: false})}
                    home={!userId && !localStorage.KON_USER_ID}
                />
                {error ? <div className='container'>
                    <div className='search-result__wrapper_error'>
                        <img src={require('../../assets/no_requests.svg')} />
                        <div className='search-result__group'>
                            <div className='not-found' style={{textAlign: 'center'}}>Приносим свои извинения за временные технические неполадки, но скоро все заработает!</div>
                        </div>
                    </div>
                </div> : ''}
                {isShowResults
                    ? <OpenedCountriesResultsView
                        countries={countries}
                        q={q}
                        onChangeQ={(value: string) => this.onChangeQ(value)}
                        loading={loading}
                    />
                    : <div>
                        <InfiniteScroll dataLength={1} next={() => console.log()} hasMore={false} endMessage={<div/>}>
                            <OpenedCountriesHomeView
                                filters={filters}
                                setFilters={(key: string) => this.setFilters(key)}
                            />
                        </InfiniteScroll>
                        <div className='footer-button__wrapper' onClick={() => this.onSearch()}>
                            <div className='button blue center'>{i18next.t('search_results')}</div>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(OpenedCountriesHomeContainer));



// WEBPACK FOOTER //
// ./src/components/OpenedCountries/OpenedCountriesHomeContainer.tsx